import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import { dataService } from '../../Services/data-service';
import { toastr } from "react-redux-toastr";
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';

class ServiceComponent extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            dialogTitle: "",
            dialogContext: "",
            selectedServiceID: 0,
            selectedServiceName: ""
        }
    }

    openDialog = (serviceID, serviceName) => {
        this.setState({
            dialogTitle: `Restart "${serviceName}"`,
            dialogContext: `Are you sure you want to restart "${serviceName}"?`,
            selectedServiceID: serviceID,
            selectedServiceName: serviceName,
            open: true
        });
    };

    restartService = () => {
        console.log("start restart service");
        dataService.restartService(this.state.selectedServiceID, 13).then((result) => {  //this.props.authReducer.userID
            if (result && result.Succeeded) {
                toastr.success(`Restart ${this.state.selectedServiceName} succeeded`, `Restart ${this.state.selectedServiceName} is succesfully requested.`);
            }
            else {
                toastr.error(`Restart ${this.state.selectedServiceName} failed`, `Restart ${this.state.selectedServiceName} request failed.`);
            }
        });
        this.closeDialog();
    };

    closeDialog = () => {
        console.log("close dialog called")
        this.setState({
            dialogTitle: "",
            dialogContext: "",
            selectedServiceID: 0,
            selectedServiceName: "",
            open: false
        });
    };

    render() {

        const { classes } = this.props;
        
        const PaperComponent = (props) => {
            return (
                <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                    <Paper {...props} />
                </Draggable>
            );
        }

        const MapStatus = (statusId) => {
            let status = "Unknown";
            
            switch(statusId) {
                case 1:
                    status = "Stopped";
                    break;
                case 2:
                    status = "Start pending";
                    break;
                case 3:
                    status = "Stop pending";
                    break;
                case 4:
                    status = "Running";
                    break;
                case 5:
                    status = "Continue pending";
                    break;
                case 6:
                    status = "Pause pending";
                    break;
                case 7:
                    status = "Paused";
                    break;
            }

            return status;          
        }

        const MapStatusColor = (statusId) => {
            let statusColorHex = "Unknown";
            
            switch(statusId) {
                case 1:
                    statusColorHex = "#cb4335";
                    break;
                case 2:
                    statusColorHex = "#1d8348";
                    break;
                case 3:
                    statusColorHex = "#cb4335";
                    break;
                case 4:
                    statusColorHex = "#1d8348";
                    break;
                case 5:
                    statusColorHex = "#1d8348";
                    break;
                case 6:
                    statusColorHex = "#d4ac0d";
                    break;
                case 7:
                    statusColorHex = "#d4ac0d";
                    break;
            }

            return statusColorHex;          
        }

        return (
            <React.Fragment>
                <div className={classes.service} >
                    <div className={classes.serviceInfoIcon}>
                        <Tooltip title={this.props.service.Description}>
                            <InfoIcon className={classes.infoIcon} />
                        </Tooltip>
                        </div>
                    <div className={classes.serviceName}>{this.props.service.Name}</div>
                    <div className={classes.restartCombo} onClick={() => this.openDialog(this.props.service.ID, this.props.service.Name)}>             
                        <div className={classes.restart}>RESTART</div>
                        <div className={classes.img}><img src={process.env.PUBLIC_URL + '/img/restart.png'}></img></div>
                        <div className={classes.serviceStatus} style={{ color: MapStatusColor(this.props.service.Status) }} >{MapStatus(this.props.service.Status)}</div>
                    </div>
                </div>
                <Dialog
                    open={this.state.open}
                    PaperComponent={PaperComponent}
                    aria-labelledby="draggable-dialog-title"
                >
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {this.state.dialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {this.state.dialogContext}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={this.closeDialog} color="primary">
                            CANCEL
                        </Button>
                        <Button autoFocus onClick={this.restartService} color="primary">
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

const styles = {
    service: {
        width: "calc(100% - 25px)",
        height: "50px",
        float: "left",
        marginBottom: "10px",
        marginRight: "10px",
        marginLeft: "0px",
        paddingTop: "16px",
        paddingLeft: "15px",
        paddingRight: "15px",
        boxSizing: "border-box",
        backgroundColor: "#F5F5F5"

    },
    serviceStatus:{
        float: "right",
        fontSize: "16px",
        fontFamily: "proxima-nova, sans-serif",
        color: "#1583C3",
        fontWeight: "bold",
        paddingTop: "1px",
        paddingRight: "10px"
    },
    restart: {
        float: "right",
        fontSize: "16px",
        fontFamily: "proxima-nova, sans-serif",
        color: "#1583C3",
        fontWeight: "bold",
        paddingTop: "1px"
    },
    serviceName: {
        fontSize: "16px",
        fontFamily: "proxima-nova, sans-serif",
        color: "#616A6E",
        float: "left"
    },
    serviceInfoIcon: {
        height: "15px",
        color: "#616A6E",
        float: "left",
        marginRight: "15px"
    },
    restartCombo: {
        cursor: "pointer"
    },
    img: {
        float: "right",
        marginRight: "5px"
    },
    infoIcon: {
        height: "15px"
    }
};

export default withStyles(styles)(ServiceComponent);